import React, { useState, useEffect } from 'react';
import { Container } from '../ui/Container';
import { CONFIG } from '../../Constants/Packages';
import { getImagePath } from '../../Utils/Utilities';
import { useIsMobile } from '../../Hooks/useIsMobile';

const testimonialData = [
  {
    name: "Mr. Shri Shankar",
    company: "Solar Power Tech Solutions",
    location: "Coimbatore, Tamil Nadu",
    comment: "The quick response to my query made online. The courtesy extended to us by your support executive was so good. Overall I will rate you 100% satisfied."
  },
  {
    name: "Ramlah Ghadiali",
    company: "Taheri Enterprises",
    location: "Mumbai, Maharashtra",
    comment: "I have used various CRM but this is the most convenient and easy app to use, also at extremely reasonable rates."
  },
  {
    name: "Mr. Sambhaji Patil",
    company: "Essarcon",
    location: "Kolhapur, Maharashtra",
    comment: "Fast Response. Good service. Lowest Rates than others with more Features! Connected with Biziverse from more than 10 Months. Satisfied with service."
  },
  {
    name: "SP Sharma",
    company: "Creative Tools",
    location: "Noida, Uttar Pradesh",
    comment: "Using Biziverse CRM+ERP. Excellent software, also staff employees have good knowledge. Prompt in solving the issues. Their Learning sessions are very useful."
  },
  {
    name: "Bharadwaj Reddy",
    company: "MARVEL INDIA CORPORATION",
    location: "Hyderabad, Telangana",
    comment: "I recommend Biziverse software for its economical price and awesome features. It's the lowest-priced, worthwhile CRM and accounting software I've encountered."
  },
  {
    name: "Mr. Nilesh Ahirrao",
    company: "Solar Power Tech Solutions",
    location: "Nashik, Maharashtra",
    comment: "Really appreciate the quick response. The response was prompt and professional. Technical support is very friendly, patient, and helpful in finding us what we were looking for."
  },
];

const TestimonialsSection = ({ brandLogo = getImagePath('/Images/QikERP.png') }) => {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [visibleCards, setVisibleCards] = useState(new Set());
  const isMobile = useIsMobile()

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swiped left (mobile only)
    }
    if (touchStart - touchEnd < -50) {
      // Swiped right (mobile only)
    }
  };

  const googleReviews = [
    {
      comment: "I recommend Biziverse software for its economical price and awesome features. It's the lowest-priced, worthwhile CRM and accounting software I've encountered.",
      name: "Bharadwaj Reddy",
      company: "MARVEL INDIA CORPORATION",
      location: "Hyderabad, Telangana"
    },
    {
      comment: "Very useful software for managing business. Easy to use and the support team is always helpful and responsive.",
      name: "Rakesh Gupta",
      company: "Gupta Traders",
      location: "Delhi"
    },
    {
      comment: "Best ERP software at this price point. Covers everything from billing to inventory. Highly recommended for SMEs.",
      name: "Priya Mehta",
      company: "Mehta Industries",
      location: "Ahmedabad, Gujarat"
    }
  ];

  const [googleIndex, setGoogleIndex] = useState(0);
  const [googleVisible, setGoogleVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setGoogleVisible(false);
      setTimeout(() => {
        setGoogleIndex((prev) => (prev + 1) % googleReviews.length);
        setGoogleVisible(true);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Intersection Observer for fade-in/fade-out animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Card entering viewport - add to visible set
            setVisibleCards((prev) => new Set([...prev, entry.target.id]));
          } else {
            // Card leaving viewport - remove from visible set
            setVisibleCards((prev) => {
              const updated = new Set(prev);
              updated.delete(entry.target.id);
              return updated;
            });
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Observe all testimonial cards
    const cards = document.querySelectorAll('[data-testimonial-card]');
    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);
  return (
    <section id="testimonials" className={`${!isMobile ? 'bg-background-light' : 'bg-white'} py-12 md:py-16 border-top lg:py-20`}>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeOutDown {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(30px);
          }
        }
        
        [data-testimonial-card] {
          opacity: 0;
          transform: translateY(30px);
        }
        
        [data-testimonial-card].fade-in-card {
          animation: fadeInUp 0.6s ease-out forwards;
        }

        [data-testimonial-card]:not(.fade-in-card) {
          animation: fadeOutDown 0.6s ease-out forwards;
        }
        
        [data-testimonial-card]:nth-child(1).fade-in-card { animation-delay: 0s; }
        [data-testimonial-card]:nth-child(2).fade-in-card { animation-delay: 0.1s; }
        [data-testimonial-card]:nth-child(3).fade-in-card { animation-delay: 0.2s; }
        [data-testimonial-card]:nth-child(4).fade-in-card { animation-delay: 0.3s; }
        [data-testimonial-card]:nth-child(5).fade-in-card { animation-delay: 0.4s; }
        [data-testimonial-card]:nth-child(6).fade-in-card { animation-delay: 0.5s; }

        [data-testimonial-card]:nth-child(1):not(.fade-in-card) { animation-delay: 0s; }
        [data-testimonial-card]:nth-child(2):not(.fade-in-card) { animation-delay: 0.1s; }
        [data-testimonial-card]:nth-child(3):not(.fade-in-card) { animation-delay: 0.2s; }
        [data-testimonial-card]:nth-child(4):not(.fade-in-card) { animation-delay: 0.3s; }
        [data-testimonial-card]:nth-child(5):not(.fade-in-card) { animation-delay: 0.4s; }
        [data-testimonial-card]:nth-child(6):not(.fade-in-card) { animation-delay: 0.5s; }
      `}</style>
      <Container className="max-w-[1350px]">
        <div className="text-center">
          {/* Header */}
          <h2 className="mb-2">
            <div className="flex justify-center mb-4 relative">
              <img
                src={brandLogo}
                alt={CONFIG.bzPrdName}
                className={`${brandLogo.includes('Biziverse.png') ? 'h-14' : 'h-28'}  object-contain`}
              />
              {isMobile && !brandLogo.includes('Biziverse.png') && (
                <div className="flex flex-col items-center absolute top-[83px]" style={{ right: '5.25rem' }}>
                  <span className="text-sm text-primary font-bold mb-0.5">by</span>
                  <img
                    src={getImagePath("/Images/Biziverse.png")}
                    alt="Biziverse"
                    className="h-[26px] w-auto object-contain"
                  />
                </div>
              )}
              {!isMobile && !brandLogo.includes('Biziverse.png') && (
                <div className="flex flex-col items-center absolute top-[83px]" style={{ right: '36.25rem' }}>
                  <span className="text-sm text-primary font-bold mb-0.5">by</span>
                  <img
                    src={getImagePath("/Images/Biziverse.png")}
                    alt="Biziverse"
                    className="h-[26px] w-auto object-contain"
                  />
                </div>
              )}


            </div>
            <div className='md:hidden flex justify-center mt-12'><img src={getImagePath("/videos/Indiagif2.gif")} alt="India" className="h-[174px] w-auto object-contain flex-shrink-0" /></div>
            <span className="md:hidden block text-[28px] font-[600] text-text-primary mt-[50px]">
              Trusted by <span className="md:hidden text-[33px] font-[600] text-[#e88421] tracking-tight">{CONFIG.cntCstrsStr}+</span>
            </span>
            <span className="md:hidden block text-[28px] font-[600] text-text-primary mt-0">
              Businesses across India
            </span>
          </h2>

          {/* Desktop Trusted By Banner */}
          <div className="hidden md:flex items-center gap-[3.18rem] mb-8 md:mb-12 p-5 bg-white mt-16 justify-center mx-4 border border-border" style={{ borderRadius: '5px' }}>
            <img src={getImagePath("/videos/Indiagif2.gif")} alt="India" className="h-[174px] w-auto object-contain flex-shrink-0" />
            <div className="text-left">
              <p className="text-[37px] text-text-primary font-semibold leading-relaxed">
                Trusted by <span className="text-[#e88421] font-[600] text-[50px]">{CONFIG.cntCstrsStr}+</span> Businesses across India
              </p>
              <p className="text-[25px] text-text-primary font-normal text-center leading-relaxed mt-2">
                Manufacturers <span className="text-[#e88421] mx-1.5">•</span> Traders
                <span className="text-[#e88421] mx-1.5">•</span>
                Retailers <span className="text-[#e88421] mx-1.5">•</span> Service Providers
              </p>
            </div>
          </div>

          {/* Mobile Trusted By - unchanged */}
          <p className="md:hidden text-base text-text-primary font-semibold mb-8 mt-5 px-4 leading-relaxed">
            Manufacturers<span className="text-[#e88421] mx-2">•</span>Traders
            <br />
            Retailers<span className="text-[#e88421] mx-2">•</span>Service Providers
          </p>

          {/* Testimonial Slider */}
          <div className="relative mb-8 md:mx-4">

            {/* Mobile View - Horizontal Scroll Cards */}
            <div className="md:hidden">
              <div className="flex overflow-x-auto overflow-y-hidden gap-4 px-4 pb-4 snap-x snap-mandatory fade-in" style={{ scrollbarWidth: 'none' }}>
                {testimonialData.map((testimonial, index) => (
                  <div
                    key={index}
                    id={`testimonial-mobile-${index}`}
                    className={`flex-shrink-0 w-[90%] snap-start ${!isMobile ? 'bg-white' : 'bg-background-light'} p-5 text-left flex flex-col justify-between overflow-hidden`}
                    style={{ minHeight: '220px', borderRadius: '5px', boxShadow: '0 3px 5px rgba(0,0,0,0.1)' }}
                  >
                    <div>
                      <div className="text-[#e88421] text-[14px] mb-3">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                      </div>
                      <p className="text-sm leading-5 text-text-primary">
                        {testimonial.comment}
                      </p>
                    </div>
                    <div className="mt-4">
                      <strong className="block text-sm font-bold text-text-primary">{testimonial.name}</strong>
                      <span className="text-xs text-text-secondary">
                        {testimonial.company}<br />
                        ({testimonial.location})
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop View - Image + 6 Testimonials Grid */}
            <div className="hidden md:flex gap-4 items-stretch">
              {/* Left - Image */}
              <div className="flex-shrink-0 border-border border rounded-xl">
                <img src={getImagePath("/Images/BizTestIcons.png")} alt="India" className="h-full w-72 rounded-lg border border-border" />
              </div>

              {/* Right - 6 Testimonials in 3 columns */}
              <div className="flex-1">
                <div className="w-full grid grid-cols-3 gap-6">
                  {testimonialData.map((testimonial, index) => (
                    <div
                      key={index}
                      id={`testimonial-desktop-${index}`}
                      data-testimonial-card
                      className={`bg-white p-6 text-start overflow-hidden border border-border flex flex-col ${visibleCards.has(`testimonial-desktop-${index}`) ? 'fade-in-card' : ''
                        }`}
                      style={{ borderRadius: '5px', boxShadow: '0 3px 5px rgba(0,0,0,0.1)' }}
                    >
                      <div className="text-[#e88421] text-xs mb-4">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                      </div>
                      <p className="text-sm leading-relaxed text-text-primary mb-2">
                        {testimonial.comment}
                      </p>
                      <div className="mt-auto">
                        <h4 className="font-bold text-text-primary text-base mb-1">{testimonial.name}</h4>
                        <p className="text-xs text-text-secondary">
                          {testimonial.company}<br />
                          <span className="text-text-light">({testimonial.location})</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Google Reviews Section - MOBILE ONLY */}
          <div className="md:hidden">
            <img src={getImagePath("/Images/GoogleRating.png")} className="w-[80%] mx-auto" />

            {/* Google Review Quote - Animated */}

          </div>


        </div>
      </Container>
    </section >
  );
};

export default TestimonialsSection;